import { render, staticRenderFns } from "./Monitoringserver copy.vue?vue&type=template&id=4355ce57"
import script from "./Monitoringserver copy.vue?vue&type=script&lang=js"
export * from "./Monitoringserver copy.vue?vue&type=script&lang=js"
import style0 from "./Monitoringserver copy.vue?vue&type=style&index=0&id=4355ce57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports